import { z } from 'zod';

/** GET /health: o processo está de pé (liveness). Não toca em dependências. */
export const HealthResponse = z.object({
  status: z.literal('ok'),
  version: z.string(),
  uptimeSeconds: z.number().nonnegative(),
});
export type HealthResponse = z.infer<typeof HealthResponse>;

export const CheckStatus = z.enum(['ok', 'error']);

/** GET /ready: pronto para receber tráfego (readiness). Checa o Postgres. */
export const ReadyResponse = z.object({
  status: z.enum(['ready', 'not_ready']),
  checks: z.object({ database: CheckStatus }),
});
export type ReadyResponse = z.infer<typeof ReadyResponse>;

/** Formato padrão de erro da API. */
export const ErrorResponse = z.object({
  error: z.string(),
  message: z.string(),
  requestId: z.string().optional(),
});
export type ErrorResponse = z.infer<typeof ErrorResponse>;
